<template>
  <q-card flat class="justify-center">
    <q-dialog v-model="modalSend" persistent>
      <q-card>
        <q-card-section>
          <div v-if="sendTest" class="text-h6">
            {{ $t('test_email_sent_to') }} <b>{{ user.email }}</b>
          </div>
        </q-card-section>
        <q-card-actions align="center">
          <q-btn
            class="q-px-md"
            no-caps
            label="OK"
            color="primary"
            v-close-popup
            @click="() => this.$emit('tabListing')"
          />
        </q-card-actions>
        <q-card-section class="q-pt-none" />
      </q-card>
    </q-dialog>

    <q-form @submit="sendMail">
      <q-card-section class="row q-col-gutter-md">
        <div class="col-4">
          <q-select
            v-model="params.campaignSelected"
            :bg-color="params.campaignSelected?.length === 0 ? 'yellow-3' : ''"
            :options="campaignsFiltered"
            :label="$t('select_campaigns')"
            outlined
            option-label="name"
            option-value="id"
            clear-icon="mdi-close"
            clearable
            use-chips
            multiple
            input-debounce="0"
            @filter="filterCampaigns"
            @input="handleCampaignSelection"
            @clear="handleCampaignClear"
          />
        </div>
        <div class="col-4">
          <q-select
            :disable="!isSingleCampaignSelected"
            v-model="params.channelSelected"
            :options="filteredChannels"
            :label="$t('choose_channel_or_all')"
            multiple
            use-chips
            outlined
            option-label="site_name"
            option-value="site_id"
            clear-icon="mdi-close"
            clearable
            use-input
          >
            <template v-slot:selected-item="scope">
              <q-chip
                removable
                size="0.8rem"
                @remove="scope.removeAtIndex(scope.index)"
                :tabindex="scope.tabindex"
                color="primary"
                text-color="white"
                square
                icon-remove="close"
                input-class="text-caption"
              >
                {{ scope.opt.site_name }}
              </q-chip>
            </template>
          </q-select>
        </div>
        <div class="col-4">
          <q-select
            v-model="params.mailing_type_id"
            ref="type"
            :label="$t('type')"
            outlined
            clearable
            clear-icon="mdi-close"
            :options="mailingTypeOptions"
            option-label="label"
            option-value="value"
            :rules="params.mailing_type_id == null ? [isRequired] : $refs.type.resetValidation()"
            :error-message="$t('is_required')"
          />
        </div>
        <div class="col-12">
          <q-input
            ref="email"
            v-model="params.email"
            :label="$t('insert_email')"
            outlined
            clearable
            clear-icon="mdi-close"
            :rules="params.campaignSelected.length === 0 ? [isRequired] : $refs.email.resetValidation()"
            lazy-rules
            :error-message="$t('insert_valid_email_or_select_campaign')"
          />
        </div>
        <div class="col-12">
          <q-input ref="subject" outlined type="text" v-model="params.subject" :label="$t('subject')"> </q-input>
        </div>
        <div class="col-12">
          <q-input
            ref="html"
            v-model="params.html"
            outlined
            type="textarea"
            lazy-rules
            rows="10"
            :placeholder="$t('paste_html_here')"
          />
        </div>

        <div class="col-12 q-py-md row justify-end">
          <q-btn color="positive" :label="$t('preview')" no-caps unelevated class="col-2" @click="viewMail" />
          <q-btn color="positive" :label="$t('save')" no-caps unelevated class="col-2 q-ml-md" @click="saveMail" />
          <q-btn
            color="positive"
            :label="$t('send_test_email')"
            no-caps
            unelevated
            class="col-2 q-ml-md"
            @click="sendtestMail"
          />
          <q-btn color="primary" :label="$t('send')" no-caps unelevated type="submit" class="col-2 q-ml-md" />
        </div>
      </q-card-section>
    </q-form>
  </q-card>
</template>

<script>
import CampaignMixin from '../../../mixins/CampaignMixin';
export default {
  mixins: [CampaignMixin],
  name: 'MailingContentRegistration',

  props: {
    campaignList: []
  },

  data() {
    return {
      sendTest: false,
      modalSend: false,
      campaignsFiltered: [],

      params: {
        campaignSelected: [],
        channelSelected: [],
        email: '',
        subject: '',
        html: '',
        mailing_type_id: null
      },
      mailingTypeOptions: []
    };
  },

  computed: {
    isSingleCampaignSelected() {
      return this.params.campaignSelected.length === 1;
    }
  },

  created() {
    this.loadMailingTypes();
  },

  methods: {
    filterCampaigns(val, update) {
      update(() => {
        const needle = val.toLocaleLowerCase();
        if (!needle) this.campaignsFiltered = this.campaignList;
        this.campaignsFiltered = this.campaignList.filter((v) => v.name.toLocaleLowerCase().indexOf(needle) > -1);
      });
    },

    handleCampaignSelection() {
      if (this.params.campaignSelected.length === 1) {
        this.getChannelsById(this.params.campaignSelected[0].id);
      } else {
        this.params.channelSelected = [];
        this.getChannelsById();
      }
    },

    handleCampaignClear() {
      this.params.channelSelected = [];
      this.getChannelsById();
    },

    viewMail() {
      if (this.params.html) {
        this.$emit('viewMail', this.params.html);
      } else {
        this.getChannelsById();
      }
    },


    async saveMail(e) {
      this.onLoading(true);
      if (!this.params.email && this.params.campaignSelected.length === 0) {
        this.errorNotify(this.$t('insert_valid_email_or_select_campaign'));
        this.onLoading(false);
        this.$refs.email.focus();
        return;
      }
      if (!this.params.subject) {
        this.errorNotify(this.$t('subject_required'));
        this.onLoading(false);
        this.$refs.subject.focus();
        return;
      }
      if (!this.params.html) {
        this.errorNotify(this.$t('paste_html'));
        this.onLoading(false);
        this.$refs.html.focus();
        return;
      }
      let lastCaracter = this.params.email.charAt(this.params.email.length - 1);
      if (lastCaracter == ';') this.params.email = this.params.email.slice(0, -1);

      try {
        const campaignIds = this.params.campaignSelected.map((campaign) => campaign.id).join(',');
        const { data, status } = await this.$http.post(`/v2/redirect`, {
          app: `affiliate`,
          path: '/api/mailing/',
          params: {
            data: {
              subject: this.params.subject,
              content: this.params.html,
              emails: this.params.email,
              campaign_id: campaignIds,
              sites: this.params.channelSelected.map((v) => v.site_id),
              mailing_type_id:  this.params.mailing_type_id.value
            }
          }
        });

        if (status === 200 || status === 201) {
          if (e != 'send') this.successNotify(this.$t('mailing_saved_successfully'));
          else this.successNotify(this.$t('mailing_saved_sending_now'));
          this.clear();
          return data.id;
        }
      } catch (error) {
        console.log(error);
        this.errorNotify(this.$t('problem_try_again_later'));
      } finally {
        this.onLoading(false);
      }
    },

    clear() {
      for (let i in this.params) this.params[i] = Array.isArray(this.params[i]) ? [] : '';
    },

    async sendtestMail() {
      let idMailing;
      idMailing = await this.saveMail();

      if (idMailing) {
        this.onLoading(true);
        try {
          const { status } = await this.$http.post(`/v2/redirect`, {
            app: `affiliate`,
            path: `/api/mailing/sendTest`,
            params: {
              data: {
                emails: this.user.email,
                id: `${idMailing}`
              }
            }
          });

          if (status === 200 || status === 201) {
            this.sendTest = true;
            this.modalSend = true;
          }
        } catch (error) {
          if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
        } finally {
          this.onLoading(false);
        }
      }
    },

    async sendMail() {
      let idMailing;
      idMailing = await this.saveMail('send');

      if (idMailing) {
        this.onLoading(true);
        try {
          const { status } = await this.$http.post(`/v2/redirect`, {
            app: `affiliate`,
            path: '/api/mailing/send',
            params: {
              data: {
                id: `${idMailing}`
              }
            }
          });

          if (status === 200 || status === 201) {
            this.sendTest = false;
          }
        } catch (error) {
          if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
        } finally {
          this.onLoading(false);
        }
      }
    },

    async loadMailingTypes() {
      try {
        const response = await this.$http.get('redirect?app=AFFILIATE&path=/api/mailing-types');
        this.mailingTypeOptions = response.data.map(item => ({
          value: item.id,
          label: item.name
        }));
      } catch (error) {
        console.error(this.$t('problem_try_again_later'), error);
      }
    }
  }
};
</script>
